import QRCode from "react-qr-code";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { Loading } from "../../components/Loading";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { MiniHeader } from "../../components/MiniHeader";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useSeller } from "../../hooks/useSeller";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import "./index.css";
import { telephoneToMask } from "../../functions/mask";

export function QRCodeSeller() {
  const navigate = useNavigate();
  const location = useLocation();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const { getAppConfig } = useAppConfig();
  const { pluginspace_id } = useParams();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const {
    customerToSeller,
    setCustomerToSeller,
    getSellerUser,
    getTokenSeller,
  } = useSeller();
  const [whatsapp, setWhatsApp] = useState<boolean>(false);
  const [msgWhatsApp, setMsgWhatsApp] = useState("");
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [text, setText] = useState("");

  async function defineShareLink() {
    const tk = getTokenSeller();

    if (tk && customerToSeller && customerToSeller.url) {
      await searchlocalStorage(customerToSeller);
      await createShareLink(customerToSeller);
    } else {
      const customer = await searchlocalStorage();
      if (customer) {
        setCustomerToSeller(customer);
        await createShareLink(customer);
      }
    }
  }

  async function searchlocalStorage(customerToSeller?: any) {
    const customer = localStorage.getItem("customerToSeller");
    if (customer && customer !== "undefined") {
      return JSON.parse(customer);
    } else {
      localStorage.setItem(
        "customerToSeller",
        JSON.stringify(customerToSeller)
      );
    }
    return null;
  }

  async function createShareLink(customerToSeller: any) {
    let text = ``;
    const ps = await getThisPluginspace();
    if (ps) {
      text = text.concat(
        `${ps.name}\nSeu carrinho digital está pronto! Explore nossa loja online e faça suas compras com facilidade.\nMal podemos esperar para ver suas escolhas!\n`
      );
    }
    let url = `\n${customerToSeller?.url}\n`;
    text = text.concat(url);
    const sellerUser = await getSellerUser();
    if (sellerUser && sellerUser.numberPhone) {
      text = text.concat(
        `\nPara mais informações, pode chamar no seguinte número: ${sellerUser.numberPhone}, meu nome é ${sellerUser.name}\ne estarei a disposição para qualquer dúvida`
      );
    }

    setText(url);
  }

  useEffect(() => {
    registerAccess("seller-qrcode");
    getPluginConfig();
    getConfig();
  }, []);

  async function getPluginConfig() {
    let pluginteplateId = 0;
    let plugintypeId = 0;
    const ps = await getThisPluginspace();
    if (ps && ps.type === "fashion") {
      pluginteplateId = 102;
      plugintypeId = 17;
    } else {
      pluginteplateId = 99;
      plugintypeId = 15;
    }

    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintypeId: plugintypeId,
          plugintemplateId: pluginteplateId,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const data = response.data.data;
        setWhatsApp(data.length > 0 && data[0].content.able === "1");
        setMsgWhatsApp(
          data[0]?.content.message ? data[0]?.content.message : ""
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function sendWhatsApp() {
    try {
      const number = customerToSeller?.phone
        .replace(/[^\w\s]/gi, "")
        .replace(/ /g, "");
      const name = customerToSeller?.name || "";
      const link = customerToSeller?.url || "";
      //let url = `https://web.whatsapp.com/send?phone=${number}`;
      let url = `https://api.whatsapp.com/send?phone=55${number}`;
      const msg = msgWhatsApp
        .replace("{cliente}", name)
        .replace("{link}", link);
      url += `&text=${encodeURI(msg)}&app_absent=0`;
      window.open(url);
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Algo inesperado aconteceu, tente novamente mais tarde",
      });
      console.log(error);
    }
  }

  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    setLoading(false);
  }

  useEffect(() => {
    defineShareLink();
  }, []);

  useEffect(() => {
    return () => {
      localStorage.removeItem("customerToSeller");
    };
  }, [location.pathname]);

  return (
    <div className="qrcode-seller">
      <div className="content-qrcode-seller">
        {!loadingHeader && (
          <MiniHeader
            name="qrcode-seller"
            title="Dados do Carrinho"
            fontColor={
              config?.webappcolor.fontheader
                ? config.webappcolor.fontheader
                : "#636363"
            }
            backgroundColor={
              config?.webappcolor.backgroundheader
                ? config.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div
            style={{
              overflowY: "auto",
              paddingBottom: "100px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="seller-qrcode-body">
              <QRCode
                value={customerToSeller?.url ? customerToSeller.url : ""}
                title="QR Code do carrinho"
              />
              <div className="copy-qrcode">
                <CopyToClipboard
                  text={text}
                  onCopy={() =>
                    Swal.fire({
                      icon: "success",
                      title: "Carrinho copiado com sucesso!",
                    })
                  }
                >
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    text="Copiar link"
                  />
                </CopyToClipboard>
              </div>
              {whatsapp && customerToSeller?.phone && (
                <div className="row-data" style={{ marginTop: 10 }}>
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={"#25D366"}
                    text="Enviar pelo WhatsApp"
                    style={{ width: 100 }}
                    onClick={sendWhatsApp}
                  />
                </div>
              )}
            </div>
            <div className="qrcode-data" style={{ marginTop: -20 }}>
              <div className="row-data-title">
                <p>Dados do cliente</p>
              </div>
              <div className="row-data">
                <p>
                  Código do carrinho:{" "}
                  {customerToSeller?.id ? customerToSeller.id : ""}
                </p>
              </div>
              <div className="row-data">
                <p>Nome: {customerToSeller?.name}</p>
              </div>
              <div className="row-data">
                <p>
                  CPF:{" "}
                  {customerToSeller?.cpf &&
                    (customerToSeller.cpf.length > 11
                      ? cnpj.format(customerToSeller.cpf)
                      : cpf.format(customerToSeller.cpf))}
                </p>
              </div>
              <div className="row-data">
                <p>
                  Telefone:{" "}
                  {telephoneToMask(
                    customerToSeller?.phone ? customerToSeller?.phone : ""
                  )}
                </p>
              </div>
            </div>
            <div className="footer-button-qrcode-seller">
              <MainButton
                color={
                  config?.webappcolor.fontbutton
                    ? config.webappcolor.fontbutton
                    : "#636363"
                }
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                text="Novo carrinho"
                onClick={() => navigate(`/${pluginspace_id}/category`)}
              />
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
}
